import React from 'react';
import ButtonText from '../ButtonText';

export const ButtonTestId = 'button-input';

export type ButtonProps = {
  children: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
  isOtherActionPending?: boolean;
  center?: boolean;
  testId?: string;
  secondary?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = '',
  center = false,
  isDisabled = false,
  isOtherActionPending = false,
  testId,
  secondary = false,
}: ButtonProps) => {
  const defaultBorder = 'border border-transparent rounded';
  const defaultTransition = 'transition duration-150 ease-in-out';
  const classes = `${className} ${defaultBorder} ${defaultTransition} ${
    secondary ? 'secondary-button' : 'primary-button'
  } text-white py-2 px-4 w-full
  ${
    isDisabled || isOtherActionPending
      ? 'disabled-button cursor-not-allowed'
      : ''
  } focus:outline-none`;
  return (
    <div className={`m-2 ${center ? 'flex items-center justify-center' : ''}`}>
      <button
        className={classes}
        disabled={isDisabled || isOtherActionPending}
        type={onClick ? 'button' : 'submit'}
        onClick={onClick}
        data-testid={testId || ButtonTestId}
      >
        <ButtonText isOtherActionPending={isOtherActionPending}>
          {children}
        </ButtonText>
      </button>
    </div>
  );
};

export default Button;
